import { ErrorHandlerState } from '../../../@types/state-types'

import {
  ERROR_PATH,
  FORBIDDEN_PATH,
  LISTING_DELETED_PATH,
  SESSION_NOT_FOUND_PATH,
} from '../../../services/routes/routes'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: ErrorHandlerState = {}

const slice = createSlice({
  name: 'errorHandlerFeature',
  initialState,
  reducers: {
    accessForbidden(state) {
      state.errorPage = FORBIDDEN_PATH
    },
    listingDeleted(state) {
      state.errorPage = LISTING_DELETED_PATH
      state.replaceHistory = true
    },
    sessionNotFound(state) {
      state.errorPage = SESSION_NOT_FOUND_PATH
      state.replaceHistory = true
    },
    resetError(state) {
      state.errorPage = undefined
      state.replaceHistory = undefined
    },
    progressError(state, action: PayloadAction<{ replaceHistory: boolean }>) {
      state.errorPage = ERROR_PATH
      state.replaceHistory = action.payload.replaceHistory
    },
  },
})

export default slice.reducer
export const { accessForbidden, listingDeleted, sessionNotFound, resetError, progressError } = slice.actions
